import {
  CREATE_CURRICULUM,
  CREATE_CURRICULUM_SUCCESS,
  CREATE_CURRICULUM_FAILURE,
  GET_CURRICULUM_LIST,
  GET_CURRICULUM_LIST_SUCCESS,
  GET_CURRICULUM_LIST_FAILURE,
  UPDATE_CURRICULUM,
  UPDATE_CURRICULUM_SUCCESS,
  UPDATE_CURRICULUM_FAILURE,
  VIEW_CURRICULUM,
  VIEW_CURRICULUM_SUCCESS,
  VIEW_CURRICULUM_FAILURE,
  UPDATE_STATUS_CURRICULUM,
  UPDATE_STATUS_CURRICULUM_SUCCESS,
  UPDATE_STATUS_CURRICULUM_FAILURE,
  GET_ACTIVE_CURRICULUM_LIST,
  GET_ACTIVE_CURRICULUM_LIST_SUCCESS,
  GET_ACTIVE_CURRICULUM_LIST_FAILURE,
} from "../../Actions/types";

const initialState = {
  createCurriculumLoader: false,
  createCurriculumError: false,
  createCurriculumData: null,
  getCurriculumListData: null,
  getCurriculumListLoader: false,
  getCurriculumListError: false,
  updateCurriculumData: null,
  updateCurriculumLoader: false,
  updateCurriculumError: false,
  viewCurriculumData: null,
  viewCurriculumLoader: false,
  viewCurriculumError: false,
  updateStatusCurriculumLoader: false,
  updateStatusCurriculumData: null,
  updateStatusCurriculumError: false,
  getActiveCurriculumListData: null,
  getActiveCurriculumListLoader: false,
  getActiveCurriculumListError: false,
};
function curriculumManagementReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_CURRICULUM:
      return { ...state, createCurriculumLoader: true };
    case CREATE_CURRICULUM_SUCCESS:
      return {
        ...state,
        createCurriculumData: action?.payload,
        createCurriculumLoader: false,
      };
    case CREATE_CURRICULUM_FAILURE:
      return {
        ...state,
        createCurriculumLoader: false,
        createCurriculumError: true,
      };
    case GET_CURRICULUM_LIST:
      return { ...state, getCurriculumListLoader: true };
    case GET_CURRICULUM_LIST_SUCCESS:
      return {
        ...state,
        getCurriculumListData: action?.payload,
        getCurriculumListLoader: false,
      };
    case GET_CURRICULUM_LIST_FAILURE:
      return {
        ...state,
        getCurriculumListLoader: false,
        getCurriculumListError: true,
      };

    case UPDATE_CURRICULUM:
      return { ...state, updateCurriculumLoader: true };
    case UPDATE_CURRICULUM_SUCCESS:
      return {
        ...state,
        updateCurriculumData: action?.payload,
        updateCurriculumLoader: false,
      };
    case UPDATE_CURRICULUM_FAILURE:
      return {
        ...state,
        updateCurriculumLoader: false,
        updateCurriculumError: true,
      };

    case UPDATE_STATUS_CURRICULUM:
      return { ...state, updateStatusCurriculumLoader: true };
    case UPDATE_STATUS_CURRICULUM_SUCCESS:
      return {
        ...state,
        updateStatusCurriculumData: action?.payload,
        updateStatusCurriculumLoader: false,
      };
    case UPDATE_STATUS_CURRICULUM_FAILURE:
      return {
        ...state,
        updateStatusCurriculumLoader: false,
        updateStatusCurriculumError: true,
      };

    case VIEW_CURRICULUM:
      return { ...state, viewCurriculumLoader: true };
    case VIEW_CURRICULUM_SUCCESS:
      return {
        ...state,
        viewCurriculumData: action?.payload,
        viewCurriculumLoader: false,
      };
    case VIEW_CURRICULUM_FAILURE:
      return {
        ...state,
        viewCurriculumLoader: false,
        viewCurriculumError: true,
      };

    case GET_ACTIVE_CURRICULUM_LIST:
      return {
        ...state,
        getActiveCurriculumListLoader: true,
      };
    case GET_ACTIVE_CURRICULUM_LIST_SUCCESS:
      return {
        ...state,
        getActiveCurriculumListData: action?.payload,
        getActiveCurriculumListLoader: false,
      };

    case GET_ACTIVE_CURRICULUM_LIST_FAILURE:
      return {
        ...state,
        getActiveCurriculumListLoader: false,
        getActiveCurriculumListError: true,
      };

    default:
      return state;
  }
}

export default curriculumManagementReducer;
